module.exports = "https://static.cdns.space/classicbook-temp-tx/img/3-3.73542020.jpg";